import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { p, selectObjects } from "~/misc/common";
import moment from "moment";

export default class extends Controller {
	connect() {
		console.log('initLessonsForm');

		const reasons = $('#toJs').data('reasons');

		refresh();
		$('#lesson_teacher_was_present').on('change', refresh);
		$('#lesson_lesson_held').on('change', refresh);
		$("#lesson_absence_reason_id").on('change', refreshReason);

		function refreshReason() {
			const reason = selectObjects(reasons, 'id', $('#lesson_absence_reason_id').myGetNumValue())[0];
			if (reason && reason.copy_reason) {
				$('#lesson_title').val(reason.name);
			} else {
				if (reason) {
					alert('Kérjük az "egyéb" lehetőséget csak nagyon speciális esetben válaszd! ' +
						'Nézd át újra a választható indokokat, és ha valamelyikre nagyjából illeszkedik ' +
						'a távolléted indoka, inkább azt válaszd! (Lent az óra címe/elmaradás oka mezőt ilyenkor is kiegészítheted ' +
						'egyéni szöveggel.) Köszönjük!');
				}
				$('#lesson_title').val('');
			}
		}

		function refresh() {
			if ($('#lesson_teacher_was_present').is(":checked") || !$('#lesson_lesson_held').is(":checked")) {
				$('#replacerHelp').hide(400);
				$('.lesson_replacer_user').hide(400);
				$('.lesson_merged').hide(400);
			} else {
				$('#replacerHelp').show(400);
				$('.lesson_replacer_user').show(400);
				$('.lesson_merged').show(400);
			}
			if ($('#lesson_lesson_held').is(":checked")) {
				$('.panel.lesson-students').show(400);
			} else {
				$('.panel.lesson-students').hide(400);
			}
			if ($('#lesson_teacher_was_present').is(":checked")) {
				$('.lesson_absence_reason').hide(400);
			} else {
				$('.lesson_absence_reason').show(400);
			}
			const title = $('.lesson_title>label').contents().last()[0] as HTMLElement;
			title.textContent = $('#lesson_lesson_held').is(":checked") ? 'Az óra címe' : 'Az óra elmaradásának oka';
			$('#lesson_title').attr('placeholder', $('#lesson_lesson_held').is(":checked") ? 'pl. Szentháromság' : 'pl. Iskolai ünnepség');
		}


		$('#lesson_started_at').parent().datetimepicker().on('dp.change', function (e: any) {
			if (e.date == null)
				return;
			const finished_at = $('#lesson_finished_at').parent().datetimepicker().data("DateTimePicker");
			if (finished_at.date() == null) {
				finished_at.date(e.date);
			} else if (e.oldDate != null) {
				finished_at.date(e.date.add(moment.duration(finished_at.date() - e.oldDate)));
			}
		});

		$('.show-comments').on('click', function () {
			$(this).toggleClass('active');
			$(this).blur();
			$('.comments').toggleClass('hidden-xs');
		});

		$('ol.curriculum > li').on('click', function () {
			p($(this).text());
			$('#lesson_title').val($(this).text());
			$('#curriculum').collapse('hide');
		});
	}
}
